module.exports = __webpack_public_path__ + "icon-quicktime.a17f65aa0fc1d4e803f7.svg";


//////////////////
// WEBPACK FOOTER
// /Users/benmeden/Documents/Projects/Maestro/abem-examiner-demo/src/assets/icons/icon-quicktime.svg
// module id = ../../../../../src/assets/icons/icon-quicktime.svg
// module chunks = styles